import { createStyles } from '../../theme/createStyles'
import { css } from '../../theme/stitches.config'

export const useStyles = createStyles(() => ({
    dropdown: css({
        overflow: 'hidden',
        border: '1px solid $colorGray200'
    })
}))
